const e = e => e.replace(/[^0-9]/g, "");
export { e as digitsOnlyFormatter };
